<svg
	width="30px"
	height="30px"
	viewBox="0 0 20 20"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	fill="currentColor"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<title>cut#1_round [#fafafa]</title> <desc>Created with Sketch.</desc> <defs />
		<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g
				id="Dribbble-Light-Preview"
				transform="translate(-300.000000, -4519.000000)"
				fill="currentColor"
			>
				<g id="icons" transform="translate(56.000000, 160.000000)">
					<path
						d="M256.02,4367.3341 C256.02,4367.0361 255.787,4366.7941 255.499,4366.7941 C255.211,4366.7941 254.978,4367.0361 254.978,4367.3341 C254.978,4367.6321 255.211,4367.8741 255.499,4367.8741 C255.787,4367.8741 256.02,4367.6321 256.02,4367.3341 L256.02,4367.3341 Z M253.163,4368.8031 L251,4372.0001 L257.012,4372.0001 L255.368,4369.8971 L254.641,4371.0051 L253.163,4368.8031 Z M259,4379.0001 L259,4379.0001 C259.552,4379.0001 260,4378.5521 260,4378.0001 L260,4377.0001 C260,4376.4481 259.552,4376.0001 259,4376.0001 C258.448,4376.0001 258,4376.4481 258,4377.0001 L258,4378.0001 C258,4378.5521 258.448,4379.0001 259,4379.0001 L259,4379.0001 Z M260,4373.0001 L258,4373.0001 L251,4373.0001 C250.448,4373.0001 250,4372.5521 250,4372.0001 L250,4367.0001 C250,4366.4481 249.552,4366.0001 249,4366.0001 C248.448,4366.0001 248,4366.4481 248,4367.0001 L248,4373.0001 C248,4374.1041 248.895,4375.0001 250,4375.0001 L258,4375.0001 L260,4375.0001 L263,4375.0001 C263.552,4375.0001 264,4374.5521 264,4374.0001 C264,4373.4481 263.552,4373.0001 263,4373.0001 L260,4373.0001 Z M250,4365.0001 L257,4365.0001 C257.552,4365.0001 258,4365.4481 258,4366.0001 L258,4371.0001 C258,4371.5521 258.448,4372.0001 259,4372.0001 C259.552,4372.0001 260,4371.5521 260,4371.0001 L260,4365.0001 C260,4363.8951 259.105,4363.0001 258,4363.0001 L250,4363.0001 L248,4363.0001 L245,4363.0001 C244.448,4363.0001 244,4363.4481 244,4364.0001 C244,4364.5521 244.448,4365.0001 245,4365.0001 L248,4365.0001 L250,4365.0001 Z M250,4360.0001 L250,4361.0001 C250,4361.5521 249.552,4362.0001 249,4362.0001 C248.448,4362.0001 248,4361.5521 248,4361.0001 L248,4360.0001 C248,4359.4481 248.448,4359.0001 249,4359.0001 C249.552,4359.0001 250,4359.4481 250,4360.0001 L250,4360.0001 Z"
						id="cut#1_round-[#fafafa]"
					/>
				</g>
			</g>
		</g>
	</g>
</svg>
